import React from 'react';
import { FadeIn } from './FadeIn';
export function StorySection() {
  return <section className="py-10 sm:py-20 px-5 sm:px-8 bg-depto-beige" data-id="element-156">
      <div className="max-w-3xl mx-auto" data-id="element-157">
        <FadeIn data-id="element-158">
          <h2 className="text-2xl sm:text-4xl text-depto-brown mb-5 sm:mb-8 text-center" data-id="element-159">
            Imaginalo por un segundo:
          </h2>
          <div className="bg-white p-6 sm:p-10 rounded-2xl sm:rounded-3xl shadow-sm border border-depto-brown/5" data-id="element-160">
            <p className="text-lg sm:text-xl text-depto-brown/90 leading-relaxed font-medium italic" data-id="element-161">
              Son las 6 de la tarde. Estás volviendo de la oficina o de cursar.
              Caminás por el palier de tu edificio y hay silencio absoluto.
              Abrís la puerta y tu perro te recibe desperezándose de una siesta,
              con el sillón intacto y sin una sola queja de la administración
              pegada en el ascensor.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}